export function shouldPrioritizeTeaserImage (
  isArticleOrArticleVersion: boolean,
  isTeaserSlider: boolean,
  includeDepth: number,
  listOrderPosition: number | null | undefined,
  teaserOrderPosition: number,
  prioritizeFirstImage = false
) {
  if (teaserOrderPosition !== 0) return false
  if (prioritizeFirstImage) return true
  return !isArticleOrArticleVersion && !isTeaserSlider && includeDepth === 0 && listOrderPosition === 0
}

export function shouldPrioritizeInitialSliderTeaser (
  listOrderPosition: number | null | undefined,
  includeDepth: number,
  isInitialSlide: boolean,
  isPreview: boolean
) {
  return !isPreview && listOrderPosition === 0 && includeDepth === 0 && isInitialSlide
}

export function shouldPreloadTeaserImage (dataSliderInitialSlide?: boolean, listOrderPosition?: number, prioritizeImage = false) {
  return prioritizeImage || (!!dataSliderInitialSlide && listOrderPosition === 0)
}

export function shouldPreloadParagraphImage (typeCount?: number, listOrderPosition?: number) {
  return typeCount === 1 && listOrderPosition === 0
}
